var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-card-professional-new-briefing"},[_c('div',{staticClass:"card-white card-project rounded gradient-bg"},[_c('h2',[_vm._v("Envie propostas pela CREATORS e fique em paz :)")]),_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":"/dashboard/professional/new-briefing"}},[_vm._v("Criar proposta")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }